import { createContext } from 'react';
import { brandedModalQuery_siteBranding_entityBrandings } from '../../types/generated/brandedModalQuery';

export const BrandingContext =
  createContext<brandedModalQuery_siteBranding_entityBrandings>(
    {} as brandedModalQuery_siteBranding_entityBrandings
  );
